import { Route } from 'react-router-dom';
import { pages } from '../../../utils/common';
import UsersAdminView from './usersAdmin.view';

const useUsersAdminRoutes = () => (
  <Route path={pages.users.path} element={<UsersAdminView />}>
    <Route index element={<UsersAdminView />} />
  </Route>
);

export default useUsersAdminRoutes;
